<script>
import ToggleSlider from "./ToggleSlider.vue";
import Button from "./Button.vue";
import {getInfo} from "../../scripts/tools.js";

const items = [
  {
    'id': 1,
    'name': 'Английский язык'
  },
  {
    'id': 2,
    'name': 'Английский язык2'
  },
  {
    'id': 3,
    'name': 'Английский язык3'
  },
  {
    'id': 4,
    'name': 'Английский язык4'
  },
  {
    'id': 5,
    'name': 'Английский язык5'
  },
  {
    'id': 6,
    'name': 'Английский язык'
  },
  {
    'id': 7,
    'name': 'Английский язык'
  },
  {
    'id': 8,
    'name': 'Английский язык'
  },
  {
    'id': 9,
    'name': 'Английский язык'
  },
  {
    'id': 10,
    'name': 'Английский язык'
  },
  {
    'id': 11,
    'name': 'Английский язык'
  },
  {
    'id': 12,
    'name': 'Английский язык'
  },
  {
    'id': 13,
    'name': 'Английский язык'
  },
  {
    'id': 14,
    'name': 'Английский язык'
  },
  {
    'id': 15,
    'name': 'Английский язык'
  },
  {
    'id': 16,
    'name': 'Английский язык'
  },
]

export default {
  name: "Filter",
  components: {Button, ToggleSlider},
  props: ['modelValue', 'showButtons'],
  data(){
    return{
      items: [],
      filters: [],
      message: ''
    }
  },
  methods: {
    clickBack(event){
      this.$emit('backButton', event);
      this.message = '';
    },
    filterReset(){
      this.filters = [];
      this.message = '';
    },
    async clickSetFilter(event){
      this.message = '';
      if(this.filters.length < 3){
        this.message = 'Для получения результатов в онлайн-калькуляторе ЕГЭ необходимо выбрать по трём или более предметам'
        return;
      }

      let result = await getInfo('set-filter', this.filters)
      if(result.length > 0){
        let objFilter = {
          'id': 'filter',
          'name': 'filter',
          'items': result
        };

        this.$emit('update:modelValue', objFilter)
        this.$emit('nextButton', event)
      }else{
        this.message = 'Набор вступительных испытаний, выбранных вами, не заявлен ни в одном направлении подготовки специальности нашего вида';
      }
    },
  },
  async created() {
    //TODO: Убрать из финальной сборки
    if(appBuild === 'prod'){
      this.items = await getInfo('filter-items');
    }else{
      this.items = items;
    }
    this.filterReset()
  }
}
</script>

<template>
  <div class="filter-block">
    <div class="filter-items">
      <ToggleSlider
          v-for="(item, index) in items"
          :key="'filter-'+item.id"
          v-model="filters"
          :name="'filter-'+item.id"
          :value="item.id"
      >
        {{item.name}}
      </ToggleSlider>
    </div>

    <div class="buttons-block" v-if="showButtons">
      <Button class="blue" @click.prevent="clickBack">Назад к выбору</Button>
      <div class="group-buttons">
        <Button class="blue" @click.prevent="filterReset">Сбросить</Button>
        <Button class="orange" @click.prevent="clickSetFilter">Применить</Button>
      </div>
    </div>

    <div class="message" v-html="message" v-if="message"></div>
  </div>
</template>

<style scoped lang="scss">
  @import "/src/style/variable";
  .filter-block {
    border-bottom: 1px solid $color-blue-opacity-03;
    border-top: 1px solid $color-blue-opacity-03;
    padding: 25px 0;
    .filter-items {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 30px;
      margin-bottom: 60px;
      @media #{$media-820}{
        grid-template-columns: repeat(2, 1fr);
      }
      @media #{$media-575}{
        grid-template-columns: repeat(1, 1fr);
      }
    }
    .buttons-block {
      display: flex;
      justify-content: space-between;
      @media #{$media-820}{
        flex-direction: column;
      }
      .group-buttons {
        display: flex;
        gap: 15px;
        @media #{$media-820}{
          margin-top: 15px;
          justify-content: space-between;
        }
        @media #{$media-575}{
          flex-direction: column;
        }
      }
    }
    .message {
      margin-top: 40px;
      text-align: center;
      font-family: $font-family;
      font-size: 18px;
      font-weight: 600;
      color: $color-orange;
    }
  }
</style>